export default "__VITE_ASSET__mwFTB6ES__"